export default class extends ApplicationController {

  clear (event) {
    var group = $(event.currentTarget).data('group')
    $(`#${group}_begin_group`).datetimepicker('clear')
    $(`#${group}_end_group`).datetimepicker('clear')
  }
}
